import React, { useState, useEffect } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom"
import {
    Typography, Card, CircularProgress, Paper, Button, Grid, TextField,
    MenuItem, Hidden
} from "@material-ui/core"
import {
    LocationOn, AccountBalanceWallet, DateRange
} from "@material-ui/icons";
import JobDetails from './JobDetails';
import { Job } from './App';

const useStyles = makeStyles((theme: Theme) => 
    createStyles({
        jobCard: {
            marginBottom: 48,
            display: "flex"
        },
        jobInfo: {
            display: 'flex', 
            alignItems: 'center', 
            flexWrap: 'wrap',
            marginBottom: 8
        },
        jobInfoIcon: {
            marginRight: 4
        },
        jobDescription: {
            display: "flex",
            flexGrow: 1, 
            margin: 16,
            flexDirection: "column",
            justifyContent: "space-between"
        },
        jobDetailPaper: {
            [theme.breakpoints.up('lg')]: {
                maxWidth: 400,
                minWidth: 400
            },
            [theme.breakpoints.down('md')]: {
                maxWidth: 350,
                minWidth: 350
            },
            backgroundImage: "linear-gradient(#95c54b, #259a49)"
        },
        jobDetailPaperMobile: {
            [theme.breakpoints.down('xs')]: {
                // maxWidth: 275,
                minWidth: 275
            },
            backgroundImage: "linear-gradient(#95c54b, #259a49)"
        },
        search: {
            backgroundColor: "#546e7a",
            padding: 8,
            margin: 0,
            maxWidth: 1000
        },
        searchField: {
            backgroundColor: "#ffffff",
            width: 220
        },
        searchSubmit: {
            backgroundColor: "#95c54b",
            width: 220,
            height: 55,
            color: "#ffffff",
            '&:hover': {
                backgroundColor: "#649417",
                color: '#FFF'
            }
        },
        header: {
            height: 70, 
            backgroundColor: "#259a49",
            display: "flex",
            justifyContent: "center"
        },
        register: {
            borderRadius: 50, 
            backgroundColor: "#ffffff",
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 8,
            paddingBottom: 8,
            color: "#259a49",
            fontWeight: "bold",
            '&:hover': {
                backgroundColor: "#dddddd"
            }
        },
        arrows: {
            display: 'flex', 
            alignItems: 'center', 
            flexWrap: 'wrap',
            marginBottom: 12,
            marginTop: 12
        },
        arrow: {
            color: "#ffffff"
        },
        title: {
            textTransform: "uppercase"
        }
    })
);

interface Props {
    jobs?: Array<Job>
    loading: boolean
}


export default function Jobs({ jobs, loading }: Props) {

    const classes = useStyles()

    const [filteredJobs, setFilteredJobs] = useState<Array<Job>>([])
    const [keywordInput, setKeywordInput] = useState<string>('')
    const [classification, setClassification] = useState<string>('')
    const [location, setLocation] = useState<string>('')

    let { path, url } = useRouteMatch()
    const history = useHistory()

    useEffect(() => {
        if(jobs) {
           
            setTimeout(()=>{ window.parent.postMessage(document.body.scrollHeight, '*') }, 1000)
            setFilteredJobs(jobs)
        }
    }, [jobs])

    const handleSearchSubmit = () => {
        let newJobs: Array<Job>= []
        if(keywordInput !== "") {
            let keywordFilter = jobs?.filter((j: Job) => {
                return j.Position.toLowerCase().includes(keywordInput.toLowerCase()) || 
                        j.AdDetail.toLowerCase().includes(keywordInput.toLowerCase()) || 
                        j.Title.toLowerCase().includes(keywordInput.toLowerCase()) ||
                        j.ShortDescription.toLowerCase().includes(keywordInput.toLowerCase())
            })
            if(keywordFilter){
                newJobs.push(...keywordFilter)
            } 

            if(classification !== "") {
                let classificationFilter = newJobs.filter((j: Job) =>  j.Classification.includes(classification))
                newJobs = classificationFilter
            }

            if(location !== "") {
                let locationFilter = newJobs.filter((j: Job) =>  j.Location.includes(location))
                newJobs = locationFilter
            }
        } else if(classification !== "") {
            let classificationFilter = jobs?.filter((j: Job) =>  j.Classification.includes(classification))
            if(classificationFilter) {
                newJobs.push(...classificationFilter)
            }

            if(location !== "") {
                let locationFilter = newJobs.filter((j: Job) =>  j.Location.includes(location))
                newJobs = locationFilter
            }
        } else if(location !== "") {
            let locationFilter = jobs?.filter((j: Job) =>  j.Location.includes(location))
            if(locationFilter) {
                newJobs.push(...locationFilter)
            }
        } else {
            if(jobs) {
                newJobs.push(...jobs)
            }
        }
        setFilteredJobs(newJobs)
    }

    const getFontSize = (jobTitle: string) => {
        if(jobTitle.length > 18) return "h6"
        return "h5"
    }

    const getSlash = (url:String) =>{
        if (url.endsWith("/")){
            return ""
        }
        return "/"
        
    }

    const updateReadMoreAnalytics = (reference: string) => {

    }
    
    const updateApplyNowAnalytics = (reference: string) => {
    
    }


    return (
        <Switch>
            <Route exact path={path}>
                <div>
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <Grid container spacing={2} className={classes.search} justify="center">
                            <Grid item>
                                <TextField
                                    value={keywordInput}
                                    variant="outlined"
                                    placeholder="Enter Keywords"
                                    InputProps={{ className: classes.searchField }}
                                    onChange={(event: React.ChangeEvent<{ value: unknown }>) =>  setKeywordInput(event.target.value as string)} />
                            </Grid>
                            <Grid item>
                                <TextField
                                    select
                                    label={classification === "" ? "Job Classification" : ""}
                                    value={classification}
                                    variant="outlined"
                                    InputProps={{ className: classes.searchField }}
                                    InputLabelProps={{shrink: false}}
                                    onChange={(event: React.ChangeEvent<{ value: unknown }>) => setClassification(event.target.value as string)}>
                                    
                                    <MenuItem value={''}><em>None</em></MenuItem>
                                    <MenuItem value={'Trades'}>Trades</MenuItem>
                                    <MenuItem value={'Logistics, Trans, Supply'}>Logistics, Trans, Supply</MenuItem>
                                    <MenuItem value={'Hosp, Travel & Tourism'}>Hosp, Travel & Tourism</MenuItem>
                                    <MenuItem value={'Other'}>Other</MenuItem>
                                    <MenuItem value={'Manufacturing'}>Manufacturing</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item>
                                <TextField
                                    select
                                    label={location === "" ? "Location" : ""}
                                    value={location}
                                    variant="outlined"
                                    InputProps={{ className: classes.searchField }}
                                    InputLabelProps={{shrink: false}}
                                    onChange={(event: React.ChangeEvent<{ value: unknown }>) => setLocation(event.target.value as string)}>
                                    
                                    <MenuItem value={''}><em>None</em></MenuItem>
                                    <MenuItem value={'Auckland'}>Auckland</MenuItem>
                                    <MenuItem value={'Wellington'}>Wellington</MenuItem>
                                    <MenuItem value={'Silverdale'}>Silverdale</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item>
                                <Button className={classes.searchSubmit} variant="contained"
                                    onClick={() => handleSearchSubmit()}>
                                    <h3>Search</h3>
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                    <div style={{margin: 16}}>
                        <Typography style={{marginBottom: 64, marginTop: 32}} variant="h3">
                            Jobs
                        </Typography>
                        <div>
                            {loading ?
                                <div>
                                    <CircularProgress  size={60}/>
                                </div>
                            :
                                <div>
                                    <Hidden xsDown>
                                        {filteredJobs.length !== 0 && filteredJobs.map((job: Job, i: number) => (
                                            <Card className={classes.jobCard} key={i} raised>
                                                <Paper className={classes.jobDetailPaper} elevation={3}>
                                                    <div style={{margin: 16, color: "white"}}>
                                                        <Typography variant={getFontSize(job.Title)} gutterBottom className={classes.title}>
                                                            {job.Title}
                                                        </Typography>
                                                        <div className={classes.jobInfo}> 
                                                            <LocationOn className={classes.jobInfoIcon} fontSize="large"/> 
                                                            <Typography variant="h6">
                                                                {job.Location}
                                                            </Typography>
                                                        </div> 
                                                        <div className={classes.jobInfo}> 
                                                            <AccountBalanceWallet className={classes.jobInfoIcon} fontSize="large"/> 
                                                            <Typography variant="h6">
                                                                {calcSalary(job)}
                                                            </Typography>
                                                        </div> 
                                                        <div className={classes.jobInfo}> 
                                                            <DateRange className={classes.jobInfoIcon} fontSize="large"/> 
                                                            <Typography variant="h6">
                                                                {calculateExpiryDate(job.timestamp)}
                                                            </Typography>
                                                        </div> 
                                                    </div>
                                                </Paper>
                                                <div className={classes.jobDescription}>
                                                    <div>
                                                        <strong>{job.Classification} / {job.Position}</strong>
                                                        <p>{job.ShortDescription}</p>
                                                    </div>
                                                    <div style={{display: "flex"}}>
                                                        <div style={{flexGrow: 1}}>
                                                        </div>
                                                        <div>
                                                            <Button 
                                                                style={{marginRight: 16, width: 130}} 
                                                                variant="outlined" 
                                                                color="primary"
                                                                onClick={() => {
                                                                    updateReadMoreAnalytics(job.Reference)
                                                                    history.push({pathname: `${url}${getSlash(url)}${job.Reference}`})
                                                                }}>
                                                                Read More
                                                            </Button>
                                                            <Button variant="contained" color="primary" style={{width: 130}}
                                                                onClick={() => {
                                                                    updateApplyNowAnalytics(job.Reference)
                                                                    openJobApplicationInNewTab(job.Reference)
                                                                }}>
                                                                Apply Now
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                        ))}
                                        {filteredJobs.length === 0 &&
                                            <p>No Jobs found.</p>
                                        }
                                    </Hidden>
                                    <Hidden smUp>
                                        {filteredJobs.length !== 0 && filteredJobs.map((job: Job, i: number) => (
                                            <Card style={{marginBottom: 48}} key={i} raised>
                                                <Paper className={classes.jobDetailPaperMobile} elevation={3}>
                                                    <div style={{padding: 16, color: "white"}}>
                                                        <Typography variant="h5" gutterBottom>
                                                            {job.Title}
                                                        </Typography>
                                                        <div className={classes.jobInfo}> 
                                                            <LocationOn className={classes.jobInfoIcon} fontSize="large"/> 
                                                            <Typography variant="h6">
                                                                {job.Location}
                                                            </Typography>
                                                        </div> 
                                                        <div className={classes.jobInfo}> 
                                                            <AccountBalanceWallet className={classes.jobInfoIcon} fontSize="large"/> 
                                                            <Typography variant="h6">
                                                                {calcSalary(job)}
                                                            </Typography>
                                                        </div> 
                                                        <div className={classes.jobInfo}> 
                                                            <DateRange className={classes.jobInfoIcon} fontSize="large"/> 
                                                            <Typography variant="h6">
                                                                {calculateExpiryDate(job.timestamp)}
                                                            </Typography>
                                                        </div> 
                                                    </div>
                                                </Paper>
                                                <div className={classes.jobDescription}>
                                                    <div>
                                                        <strong>{job.Classification} / {job.Position}</strong>
                                                        <p>{job.ShortDescription}</p>
                                                    </div>
                                                    <div style={{display: "flex"}}>
                                                        <div style={{flexGrow: 1}}>
                                                        </div>
                                                        <div>
                                                            <Button 
                                                                style={{marginRight: 16, width: 130}} 
                                                                variant="outlined" 
                                                                color="primary"
                                                                onClick={() => {
                                                                    history.push({pathname: `${url}${getSlash(url)}${job.Reference}`})
                                                                }}>
                                                                Read More
                                                            </Button>
                                                            <Button variant="contained" color="primary" style={{width: 130}}
                                                                onClick={() => openJobApplicationInNewTab(job.Reference)}>
                                                                Apply Now
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                        ))}
                                        {filteredJobs.length === 0 &&
                                            <p>No Jobs found.</p>
                                        }
                                    </Hidden>
                                </div>

                            }
                        </div>
                    </div>
                    
                </div>
            </Route>
            <Route path={`${path}/:jobRef`}>
                <JobDetails jobs={jobs} />
            </Route>
            
        </Switch>
    )
}

export const calcSalary = (job: Job) : string => {
    if(job.SalaryMin === "" || job.SalaryMin === "0") {
        return `Not Listed`
    } else if (job.SalaryMax === "" || job.SalaryMax === "0") {
        return `Not Listed`
    } else if (parseInt(job.SalaryMin) === parseInt(job.SalaryMax)) {
        if(job.SalaryType === "annum") {
            return `$${job.SalaryMin}/p.a.`
        }
        return `$${job.SalaryMin}/${job.SalaryType}`
    }

    if(job.SalaryType === "annum") {
        return `$${job.SalaryMin}-${job.SalaryMax}/p.a.`
    }
    return `$${job.SalaryMin}-${job.SalaryMax}/${job.SalaryType}`
}

export const calculateExpiryDate = (timestamp: string) : string => {
    let timeInSecs = parseInt(timestamp)
    let date = new Date(0);
    date.setUTCSeconds(timeInSecs);
    let expiryDate = new Date(date);
    expiryDate.setDate(expiryDate.getDate() + 30);
    return expiryDate.toDateString();
}

export const openInNewTab = (jobId: string) => {
    const url = `https://d2m349vhqx9s23.cloudfront.net/#/?jobRef=${jobId}`
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
}

export const openJobApplicationInNewTab = (jobId: string) => {
    const url = `https://app.lowie.co.nz/#/apply?jobRef=${jobId}`
    // const url = `https://lowie.fasttrack360.com.au/FastTrack.Web.Questionnaire/(S(p0hk0zog2qrbce4ehgfzrhxm))/Questionnaire.page?Type=SbJobOrder&Reference=${jobId}&source=Company%20Website`
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
}